
import { EVENT_TYPES } from 'common/track-event-constants'

import LinkListItem from '../../LinkListItem'
import { useClickTracking } from '../use-click-tracking'

interface IResultComponent {
  label: string
  id?: string
  to: string
  icon?: any
  iconComp?: any
  [key: string]: any
}

const ResultComponent = ({ to, label, id, icon, iconComp }: IResultComponent) => {
  const trackClickFn = useClickTracking(EVENT_TYPES.LINK_RESULT_CLICK, to)

  return (
    <LinkListItem
      to={to}
      id={id}
      hoverText={`Visit: ${label}`}
      label={label}
      icon={icon}
      iconComp={iconComp}
      onClick={() => {
        trackClickFn()
      }}
    />
  )
}

export default ResultComponent
